/** Loader.
 *
 * @format
 */
import React from 'react';

const Loader = (): JSX.Element => <div className="loader">Loading...</div>;
export default Loader;
